import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ICmsFeatureBlock } from '@shared/interfaces/cms.interface';

@Component({
    selector: 'app-add-info-box-dialog',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, ButtonModule, InputTextModule, TextareaModule],
    templateUrl: './add-info-box-dialog.component.html',
    styleUrl: './add-info-box-dialog.component.scss'
})
export class AddInfoBoxDialogComponent implements OnInit {
    infoBoxForm!: FormGroup;
    isEditMode = false;

    constructor(
        private fb: FormBuilder,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig
    ) {}

    ngOnInit(): void {
        this.initForm();

        if (this.config.data?.featureBlock) {
            this.isEditMode = true;
            this.populateForm(this.config.data.featureBlock);
        }
    }

    initForm(): void {
        this.infoBoxForm = this.fb.group({
            title: ['', Validators.required],
            description: ['', Validators.required],
            iconName: ['', Validators.required],
            sortOrder: [0]
        });
    }

    populateForm(featureBlock: ICmsFeatureBlock): void {
        this.infoBoxForm.patchValue({
            title: featureBlock.title,
            description: featureBlock.description,
            iconName: featureBlock.iconName,
            sortOrder: featureBlock.sortOrder
        });
    }

    onSave(): void {
        if (this.infoBoxForm.valid) {
            const featureBlock: ICmsFeatureBlock = this.infoBoxForm.value;
            this.ref.close(featureBlock);
        } else {
            this.markFormGroupTouched(this.infoBoxForm);
        }
    }

    onCancel(): void {
        this.ref.close();
    }

    private markFormGroupTouched(formGroup: FormGroup): void {
        Object.values(formGroup.controls).forEach((control) => {
            control.markAsTouched();
            if ((control as any).controls) {
                this.markFormGroupTouched(control as FormGroup);
            }
        });
    }
}
